import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		heading: {
			marginBottom: theme.spacing(2),
		},
		form: {
			maxWidth: 420,
		},
	} satisfies Record<string, CSSObject>);
};
